import { ProjectData, Tags, ProjectStatus, Products, Contributors, Software, Languages, Technologies } from '@structures/ProjectData';

export const UnannouncedGame: ProjectData = {
    summary: {
        id: "UG",
        title: "Unannounced Game",
        aliases: ["Unannounced", "UG"],
        version: 0.3,
        status: ProjectStatus.Unreleased,
        initial: new Date(2024, 8, 1),
        tags: {
            [Tags.Products]: [
                Products.Tools,
                Products.Games
            ],
            [Tags.Software]: [
                Software.VS
            ],
            [Tags.Languages]: [
                Languages.CPlus,
                Languages.CSharp
            ],
            [Tags.Technologies]: [
                Technologies.WPF
            ]
        },
        description: "An unannounced game that Blizzard is working on."
    },
    details: {
        description: "It's a secret."
            + "<br/><br/>"
            + "NDA.",
        gallery: [],
        contributions: [{
            contributor: Contributors.MakoInfused,
            roles: [{
                title: "Lead Tools Engineer",
                involvement: "Develop features and lead a team of engineers to produce enhancements of an internal game editor.",
                achievements: [
                    "Developed the foundation for how processes, tools, and teams will work for the game.",
                    "Lead 6 engineers, providing metorship, technical direction and support for every step throughout the Software Development Lifecycle.",
                    "Building and owning several AI based support systems for content creation workflows.",
                    "Own critical areas of the editor, ensuring stability and providing support for content creators to make assets for the game."
                ]
            }]
        }]
    },
};

export default UnannouncedGame;